import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-appointment-request-edit',
  templateUrl: './appointment-request-edit.component.html',
  styleUrls: ['./appointment-request-edit.component.css'],
})
export class AppointmentRequestEditComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
